import React from 'react';

import { Box, Button } from '@mui/material';

import { classes } from './styles';

interface FormActionsProps {
  saveForLaterText?: string;
  nextText?: string;
  showSaveForLater?: boolean;
  fontFamily?: string;
  isDisabled?: boolean;
  previewMode?: boolean;
}

export const FormActions: React.FC<FormActionsProps> = ({
  saveForLaterText = 'Save for later',
  nextText = 'Next',
  showSaveForLater = true,
  fontFamily,
  isDisabled = false,
  previewMode = false
}) => {
  const nextSx = classes.formActions.nextButtonSx(fontFamily);
  const saveSx = classes.formActions.saveButtonSx(fontFamily);
  const buttonType = previewMode ? 'button' : 'submit';
  const formId = previewMode ? undefined : 'new_application';

  return (
    <Box
      component="section"
      data-tlp-preview-mode={previewMode ? 'true' : undefined}
      sx={classes.formActions.sectionContainerSx()}
    >
      <Box sx={classes.formActions.actionButtonsSx()}>
        {showSaveForLater ? (
          <Button
            formNoValidate
            disabled={isDisabled || previewMode}
            form={formId}
            id="application_save_for_later"
            name="commit"
            sx={saveSx}
            type={buttonType}
            value="Save"
          >
            {saveForLaterText}
          </Button>
        ) : null}
        <Button
          formNoValidate
          disabled={isDisabled || previewMode}
          form={formId}
          id="application_submit"
          name="commit"
          sx={nextSx}
          type={buttonType}
          value="Next"
        >
          {nextText}
        </Button>
      </Box>
    </Box>
  );
};

export default FormActions;
